export enum ProcessStatus{   
    CREATED = 'created',
    ACCEPTED_PAYMENT_PENDING = 'accepted_payment_pending',
    FINISHED_LINKED = 'finished_linked',
    PAYMENT_MANUAL_VALIDATION = 'payment_manual_validation',
    PAYMENT_MANUAL_REJECTED = 'payment_manually_rejected',
    REVIEW = "review",
    APPROVED= "approved",
    REJECTED = "rejected",
    CANCELLED = "cancelled",
    VALIDATED = "validated",
    RESPONSED = "responsed",
    REGISTRED = "registred",
    PAID = "paid",
    FINISHED = "finished",
    QUEUED ="queued"
}